webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return profile; });
var profile = {
  name: 'metin orak',
  initials: 'MO',
  basic: [{
    title: 'Full Name',
    content: 'Metin Orak'
  }, {
    title: 'Email',
    content: 'metinorak.apps@gmail.com'
  }, {
    title: 'Birth Year',
    content: '1995'
  }, {
    title: 'Citizenship',
    content: 'Turkey'
  }],
  additional: [{}],
  bio: {
    title: 'Bio',
    content: ['Computer Software Engineer', '\n      I\'m always learning new things and trying to find a specific and interesting area to work. About subjects that I want to learn, I read books and practice. I enjoy implementing data structures and developing algorithms for problems.\n      For upcoming plans, firstly I want to perform my own projects and increase my knowledge about artificial intelligence.\n      ']
  }
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoText_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e07407b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoText_vue__ = __webpack_require__(75);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e07407b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_bars_NameBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_bars_TitleBar_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_bars_EnterBar_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pages_PageView_vue__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      no: 'none',
      enter: false,
      pageButton: 'about',
      scroll: true
    };
  },

  computed: {},
  methods: {
    onScroll: function onScroll() {
      this.scroll = window.pageYOffset === 0;
    },
    enterCV: function enterCV() {
      this.enter = true;
    },
    change: function change(prop) {
      switch (prop) {
        case 0:
          this.pageButton = 'about';
          break;
        case 1:
          this.pageButton = 'skills';
          break;
        case 2:
          this.pageButton = 'experience';
          break;
        case 3:
          this.pageButton = 'education';
          break;
        default:
          this.pageButton = null;
      }
    }
  },
  components: {
    NameBar: __WEBPACK_IMPORTED_MODULE_0__src_components_bars_NameBar_vue__["a" /* default */],
    TitleBar: __WEBPACK_IMPORTED_MODULE_1__src_components_bars_TitleBar_vue__["a" /* default */],
    EnterBar: __WEBPACK_IMPORTED_MODULE_2__src_components_bars_EnterBar_vue__["a" /* default */],
    PageView: __WEBPACK_IMPORTED_MODULE_3__src_pages_PageView_vue__["a" /* default */]
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_basic_info__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'name-bar',
  data: function data() {
    return {
      name: __WEBPACK_IMPORTED_MODULE_0__data_basic_info__["a" /* profile */].name,
      initials: __WEBPACK_IMPORTED_MODULE_0__data_basic_info__["a" /* profile */].initials
    };
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'title-bar',
  data: function data() {
    return {
      screenSize: false,
      selected: 0,
      menuName: 'About Me',
      menuItems: [{
        title: 'About Me',
        number: 0
      }, {
        title: 'Skills',
        number: 1
      }, {
        title: 'Experience',
        number: 2
      }, {
        title: 'Education',
        number: 3
      }]
    };
  },

  watch: {
    selected: function selected() {
      this.menuName = this.menuItems[this.selected].title;
      this.$emit('changePage', this.selected);
    }
  },
  methods: {
    select: function select(item) {
      this.selected = item.number;
      this.menuName = ' ' + item.title;
    },
    onSmallScreen: function onSmallScreen() {
      if (window.innerWidth > 1000) {
        this.screenSize = false;
      } else {
        this.screenSize = true;
      }
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'enter-bar',
  methods: {
    enter: function enter() {
      this.$emit('enter');
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AboutPage_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EducationPage_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SkillsPage_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExperiencePage_vue__ = __webpack_require__(125);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  props: ['pressed'],
  components: {
    AboutPage: __WEBPACK_IMPORTED_MODULE_0__AboutPage_vue__["a" /* default */],
    EducationPage: __WEBPACK_IMPORTED_MODULE_1__EducationPage_vue__["a" /* default */],
    SkillsPage: __WEBPACK_IMPORTED_MODULE_2__SkillsPage_vue__["a" /* default */],
    ExperiencePage: __WEBPACK_IMPORTED_MODULE_3__ExperiencePage_vue__["a" /* default */]
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_text_InfoText_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bars_BasicInfoBarCol_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_bars_BasicInfoBarRow_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_basic_info_js__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',
  data: function data() {
    return {
      github: 'https://github.com/metinorak', // TODO: Insert github lunk
      linkedin: 'https://www.linkedin.com/in/metinorak', // TODO: insert linkedin link
      bio: __WEBPACK_IMPORTED_MODULE_3__data_basic_info_js__["a" /* profile */].bio
    };
  },

  components: {
    InfoText: __WEBPACK_IMPORTED_MODULE_0__components_text_InfoText_vue__["a" /* default */],
    BasicInfoBarRow: __WEBPACK_IMPORTED_MODULE_2__components_bars_BasicInfoBarRow_vue__["a" /* default */],
    BasicInfoBarCol: __WEBPACK_IMPORTED_MODULE_1__components_bars_BasicInfoBarCol_vue__["a" /* default */]
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'info-text',
  props: ['title', 'content']
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text_InfoText_vue__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'basic-info-bar-col',
  data: function data() {
    return {
      basic: profile.basic,
      additional: profile.additional
    };
  },

  components: {
    InfoText: __WEBPACK_IMPORTED_MODULE_0__text_InfoText_vue__["a" /* default */]
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text_InfoText_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_basic_info_js__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'basic-info-bar-row',
  data: function data() {
    return {
      basic: __WEBPACK_IMPORTED_MODULE_1__data_basic_info_js__["a" /* profile */].basic,
      additional: __WEBPACK_IMPORTED_MODULE_1__data_basic_info_js__["a" /* profile */].additional
    };
  },

  components: {
    InfoText: __WEBPACK_IMPORTED_MODULE_0__text_InfoText_vue__["a" /* default */]
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_text_EducationText_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_education__ = __webpack_require__(87);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'education',
  data: function data() {
    return {
      tertiary: __WEBPACK_IMPORTED_MODULE_1__data_education__["b" /* tertiary */],
      secondary: __WEBPACK_IMPORTED_MODULE_1__data_education__["a" /* secondary */]
    };
  },

  components: {
    EducationText: __WEBPACK_IMPORTED_MODULE_0__components_text_EducationText_vue__["a" /* default */]
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'education-text',
  props: ['content'],
  computed: {
    header: function header() {
      return this.content.institution + ' | ' + this.content.year;
    },
    logoLink: function logoLink() {
      // not used at this point
      return '../../assets/' + this.content.logo;
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_text_SkillsText_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_skills_js__ = __webpack_require__(123);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'skills',
  data: function data() {
    return {
      skillsInitial: __WEBPACK_IMPORTED_MODULE_3__data_skills_js__["a" /* skillExplanations */],
      skills: __WEBPACK_IMPORTED_MODULE_3__data_skills_js__["b" /* skills */],
      skillsExplained: [],
      skillsSelected: []
    };
  },

  components: {
    SkillsText: __WEBPACK_IMPORTED_MODULE_2__components_text_SkillsText_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.skillsExplained = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.skillsInitial));
  },

  methods: {
    selectSkills: function selectSkills(pressed) {
      if (this.skills[pressed].pressed) {
        this.skills[pressed].pressed = false;
        // remove selected
        this.skillsSelected.splice(this.skillsSelected.indexOf(this.skills[pressed]), 1);
        this.reorderSkills();
        // this.skills.splice(this.skills.length, 0, this.skills[pressed]);
        // this.skills.splice(pressed, 1);
      } else {
        this.skills[pressed].pressed = true;
        // add selected
        this.skillsSelected.splice(0, 0, this.skills[pressed]);
        this.reorderSkills();
        // this.skills.splice(0, 0, this.skills[pressed]);
        // this.skills.splice(pressed + 1, 1);
      }
    },
    reorderSkills: function reorderSkills() {
      this.skillsExplained = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.skillsInitial));
      // most recently selected is at index 0
      for (var itemIndex = this.skillsSelected.length - 1; itemIndex > -1; itemIndex--) {
        var item = this.skillsSelected[itemIndex];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.skillsExplained), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var skill = _step.value;

            if (skill.tags.indexOf(item.title) !== -1) {
              // add to beginning
              // remove from original
              this.skillsExplained.splice(this.skillsExplained.indexOf(skill), 1);
              this.skillsExplained.splice(0, 0, skill);
              // break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }
});

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'skills-text',
  props: ['title', 'content']
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_text_ExperienceText_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_text_ProjectText_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_projects__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_experiences__ = __webpack_require__(135);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'experience',
  data: function data() {
    return {
      projects: __WEBPACK_IMPORTED_MODULE_2__data_projects__["a" /* projects */],
      experiences: __WEBPACK_IMPORTED_MODULE_3__data_experiences__["a" /* experiences */]
    };
  },

  components: {
    ExperienceText: __WEBPACK_IMPORTED_MODULE_0__components_text_ExperienceText_vue__["a" /* default */],
    ProjectText: __WEBPACK_IMPORTED_MODULE_1__components_text_ProjectText_vue__["a" /* default */]
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'experience-text',
  props: ['content'],
  computed: {
    header: function header() {
      return this.content.title + ' | ' + this.content.company + ' | ' + this.content.date;
    }
  },
  data: function data() {
    return {
      showItem: false,
      showItemContent: null
    };
  },

  methods: {
    show: function show(item, index) {
      // mimic toggle
      this.clearSelect();
      if (this.showItem && this.showItemContent === item) {
        this.showItem = false;
        this.content.techUsed[index].show = false;
      } else {
        this.showItem = true;
        this.showItemContent = item;
        this.content.techUsed[index].show = true;
      }
    },
    clearSelect: function clearSelect() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.content.techUsed), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.show = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-text',
  props: ['content'],
  data: function data() {
    return {
      showItem: false,
      showItemContent: null
    };
  },

  methods: {
    show: function show(item, index) {
      // mimic toggle
      this.clearSelect();
      if (this.showItem && this.showItemContent === item) {
        this.showItem = false;
        this.content.techUsed[index].show = false;
      } else {
        this.showItem = true;
        this.showItemContent = item;
        this.content.techUsed[index].show = true;
      }
    },
    clearSelect: function clearSelect() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.content.techUsed), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.show = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_media_query__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_vue__ = __webpack_require__(60);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_v_media_query___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App_vue__["a" /* default */] }
});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c87b5b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(138);
function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c87b5b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NameBar_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af904e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NameBar_vue__ = __webpack_require__(64);
function injectStyle (ssrContext) {
  __webpack_require__(63)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NameBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af904e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NameBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"name-container",attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"id":"small"}},[_vm._v(_vm._s(_vm.initials))]),_vm._v(" "),_c('h1',{attrs:{"id":"full"}},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleBar_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906a931c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleBar_vue__ = __webpack_require__(67);
function injectStyle (ssrContext) {
  __webpack_require__(66)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906a931c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"title",attrs:{"flat":"","text-xs-center":""}},[_c('v-flex',{attrs:{"id":"small"}},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","transparent":""},slot:"activator"},[_vm._v("\n        "+_vm._s(_vm.menuName)+"\n        "),_c('v-icon',[_vm._v("keyboard_arrow_down")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,on:{"click":function($event){_vm.select(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}))],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"id":"full"}},[_c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-btn',{attrs:{"flat":""}},[_vm._v("About Me")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Skills")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Experience")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Education")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnterBar_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f2cec06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnterBar_vue__ = __webpack_require__(70);
function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f2cec06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-xs-center",attrs:{"pa-0":""}},[_c('v-btn',{attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){return _vm.enter($event)}}},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageView_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d67b9f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageView_vue__ = __webpack_require__(137);
function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d67b9f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_866e6472_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__ = __webpack_require__(80);
function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_866e6472_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"pa-0":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"pr-2":"","xs6":"","text-xs-right":""}},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","text-xs-left":""}},[_c('p',{attrs:{"pa-0":"","ma-0":""}},[_vm._v(_vm._s(_vm.content))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInfoBarCol_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df4ddf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInfoBarCol_vue__ = __webpack_require__(77);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInfoBarCol_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df4ddf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInfoBarCol_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"about-page"},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-avatar',{attrs:{"size":"200px"}},[_c('img',{attrs:{"src":"/static/img/avatar.jpg"}})])],1),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',_vm._l((_vm.basic),function(item){return _c('info-text',{key:item.title,attrs:{"title":item.title,"content":item.content}})})),_vm._v(" "),_c('v-flex',_vm._l((_vm.additional),function(item){return _c('info-text',{key:item.title,attrs:{"title":item.title,"content":item.content}})}))],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInfoBarRow_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b9b55c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInfoBarRow_vue__ = __webpack_require__(79);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasicInfoBarRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b9b55c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasicInfoBarRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"about-page"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-avatar',{attrs:{"size":"180px"}},[_c('img',{attrs:{"src":"/static/img/avatar.jpg"}})])],1),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',_vm._l((_vm.basic),function(item){return _c('info-text',{key:item.title,attrs:{"title":item.title,"content":item.content}})})),_vm._v(" "),_c('v-flex',_vm._l((_vm.additional),function(item){return _c('info-text',{key:item.title,attrs:{"title":item.title,"content":item.content}})}))],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"about-page width-limit-800",attrs:{"text-xs-center":""}},[_c('basic-info-bar-row',{attrs:{"id":"row"}}),_vm._v(" "),_c('basic-info-bar-col',{attrs:{"id":"col"}}),_vm._v(" "),_c('v-container',{staticClass:"divider-container",attrs:{"pa-0":"","pt-3":"","pb-3":""}},[_c('v-divider')],1),_vm._v(" "),_vm._l((_vm.bio.content),function(item){return _c('v-card',{key:item,staticClass:"transparent",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"no-space"},[_vm._v(_vm._s(item))])],1)}),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","href":this.github,"target":"_blank","pa-0":"","ma-0":""},slot:"activator"},[_c('img',{attrs:{"src":__webpack_require__(81),"size":"16px"}})]),_vm._v(" "),_c('span',[_vm._v("View GitHub Profile")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","href":this.linkedin,"target":"_blank","pa-0":"","ma-0":""},slot:"activator"},[_c('img',{attrs:{"src":__webpack_require__(82),"size":"16px"}})]),_vm._v(" "),_c('span',[_vm._v("View LinkedIn Profile")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAiCAYAAADLTFBPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMUFCQzU0MTFDN0QxMUUyQjkxNEY3RUNEMkY1ODRBRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMUFCQzU0MjFDN0QxMUUyQjkxNEY3RUNEMkY1ODRBRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUxQUJDNTNGMUM3RDExRTJCOTE0RjdFQ0QyRjU4NEFEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUxQUJDNTQwMUM3RDExRTJCOTE0RjdFQ0QyRjU4NEFEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+l63yRQAAAYpJREFUeNpiYGBgEADiCUD8f4DwApAb/v//z0AsZhhgB8MdToqjGaGaBhwAHcNIrFomhkECGBkZFYhWO2xCmomJaSGQ4oEaxM3KyrqYYZABlEzBwsJyCFviB4nTMjOSkhExQvrPnz97sPkMl/hAAFIy4r1B62hgMnDBphAonjZo0zQIAzMiqJZih9Y+7FD+/8GSpodkkcdCbcuByegJkLqPVGkI/v79W4fmyQNHIwWnPKg4BJblX4ByMTj0sgNxP7WSB1UcDQR1sDxAwLIYmqVpbOkLGM3/yUl/6AAYI4eAZb7tkGowAR3cSXHjipohDVRTByvngWre//37twJIX0dTA0rfPygJaaqkaaR0TVQ7huptDwqKOpfB2PYgJ/3aDnZHK9Ktl0OtjIgsT4pZQ7qPOGjSNK0Ay2BzEDDppCElmVlQ/hYg+xmQLQVk+wy6kAY5FJmGAieog52GUvIA1apGUHpoOBoY6meBlBSUHh0WGy3yCDl64SBwB8luAA2q03yIgIGKg+oAAQYANTTsUy3H+l8AAAAASUVORK5CYII="

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EducationPage_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48a8be8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EducationPage_vue__ = __webpack_require__(88);
function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EducationPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e48a8be8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EducationPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EducationText_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3a6c70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EducationText_vue__ = __webpack_require__(86);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EducationText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b3a6c70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EducationText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"width-limit-500 text-xs-left",attrs:{"pa-0":"","pt-2":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('h3',{staticClass:"subhead"},[_vm._v(_vm._s(_vm.header))])]),_vm._v(" "),_c('v-flex',{attrs:{"text-align-left":""}},[_c('ul',[_vm._v(_vm._s(_vm.content.description))]),_vm._v(" "),_c('ul',{staticClass:"italic"},[_vm._v(_vm._s(_vm.content.additional))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tertiary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return secondary; });
var tertiary = [{
  institution: 'Çukurova University',
  year: 'September 2014 - June 2019',
  description: 'BSc in Computer Engineering',
  additional: 'Graduated with a 71.5% average',
  logo: '<logo>'
}];

var secondary = [{
  institution: 'Sungurbey Anatolian High School',
  year: '2009 - 2013',
  description: '',
  additional: 'Graduated with a 70.67% average, mostly mathematics and science courses'
}];

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"education-page width-limit-500",attrs:{"flat":"","text-xs-left":""}},[_c('h3',{staticClass:"head"},[_vm._v("Tertiary Education")]),_vm._v(" "),_vm._l((_vm.tertiary),function(item){return _c('education-text',{key:item.title,attrs:{"content":item}})}),_vm._v(" "),_c('v-container',{staticClass:"divider-container",attrs:{"pa-0":"","pt-3":"","pb-3":""}},[_c('v-divider')],1),_vm._v(" "),_c('h3',{staticClass:"head"},[_vm._v("Secondary Education")]),_vm._v(" "),_vm._l((_vm.secondary),function(item){return _c('education-text',{key:item.title,attrs:{"content":item}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillsPage_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8550b222_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillsPage_vue__ = __webpack_require__(124);
function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8550b222_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillsText_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c174622_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillsText_vue__ = __webpack_require__(122);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkillsText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c174622_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkillsText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"width-limit-600 text-xs-left",attrs:{"pt-2":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('h3',{staticClass:"subhead"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-flex',{attrs:{"text-align-left":""}},_vm._l((_vm.content),function(item){return _c('li',{key:item},[_vm._v("\n        "+_vm._s(item)+"\n      ")])}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return skillExplanations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return skills; });
var skillExplanations = [{
  title: 'Programming Languages',
  content: ['C', 'C++', 'Java', 'Python', 'PHP', 'JavaScript'],
  tags: ['C', 'C++', 'Java', 'Python', 'PHP', 'JavaScript']
}, {
  title: 'Data Structures',
  content: ['Linked Lists, Stacks, Queues, Trees, Graph etc.'],
  tags: ['Data Structures']
}, {
  title: 'Algorithms',
  content: ['Some sorting algorithms like Selection, Insertion, Bubble, Merge, Quick etc.', 'Hashing'],
  tags: ['Algorithms']
}, {
  title: 'Platforms and Frameworks',
  content: ['Python - Flask', 'Java - Android', 'Java - Spring Framework', 'Java - Swing', 'C++ - Qt']
}];

var skills = [{
  title: 'C',
  pressed: false
}, {
  title: 'C++',
  pressed: false
}, {
  title: 'Java',
  pressed: false
}, {
  title: 'Python',
  pressed: false
}, {
  title: 'PHP',
  pressed: false
}, {
  title: 'JavaScript',
  pressed: false
}, {
  title: 'Data Structures',
  pressed: false
}, {
  title: 'Algorithms',
  pressed: false
}, {
  title: 'Android',
  pressed: false
}, {
  title: 'Swing',
  pressed: false
}, {
  title: 'Flask',
  pressed: false
}, {
  title: 'Qt',
  pressed: false
}];

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"skills-page",attrs:{"flat":"","text-xs-center":""}},[_c('v-container',{staticClass:"width-limit-1000"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',_vm._l((_vm.skills),function(item,index){return _c('v-chip',{key:index,attrs:{"outline":"","disabled":"","selected":item.pressed},nativeOn:{"click":function($event){_vm.selectSkills(index)}}},[_vm._v(_vm._s(item.title))])}))],1)],1),_vm._v(" "),_c('v-container',{staticClass:"width-limit-1000"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('transition-group',{attrs:{"name":"fade-chip"}},_vm._l((_vm.skillsSelected),function(item){return _c('v-chip',{key:item.title,attrs:{"close":"","disabled":""},on:{"input":function($event){_vm.selectSkills(_vm.skills.indexOf(item))}}},[_vm._v(_vm._s(item.title))])}))],1)],1)],1),_vm._v(" "),_c('transition-group',{attrs:{"name":"reorder"}},_vm._l((_vm.skillsExplained),function(item){return _c('skills-text',{key:item.title,attrs:{"title":item.title,"content":item.content}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperiencePage_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2912b8a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperiencePage_vue__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(126)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperiencePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2912b8a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperiencePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceText_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7c80a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceText_vue__ = __webpack_require__(129);
function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperienceText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7c80a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperienceText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"width-limit-800 text-xs-left",attrs:{"pa-0":"","pt-2":"","pb-2":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":""}},[_c('h3',{staticClass:"subhead"},[_vm._v(_vm._s(_vm.header))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"text-align-left":""}},[_c('ul',[_vm._v(_vm._s(_vm.content.description))])]),_vm._v(" "),_c('v-flex',{attrs:{"row":""}},_vm._l((_vm.content.techUsed),function(item,index){return _c('v-chip',{key:item.title,attrs:{"slot":"activator","disabled":"","selected":item.show},nativeOn:{"click":function($event){_vm.show(item.content, index)}},slot:"activator"},[_vm._v(_vm._s(item.title))])})),_vm._v(" "),_c('v-flex',{attrs:{"pt-2":""}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showItem)?_c('ul',{staticClass:"italic"},[_vm._v(_vm._s(_vm.showItemContent))]):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectText_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38eccaae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectText_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38eccaae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"width-limit-800 text-xs-left",attrs:{"pa-0":"","pt-2":"","pb-2":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-layout',{attrs:{"row":""}},[_c('h3',{staticClass:"subhead"},[_vm._v(_vm._s(_vm.content.title))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"text-align-left":"","pr-1":""}},[_c('ul',{staticClass:"italic"},[_vm._v(_vm._s(_vm.content.institution))]),_vm._v(" "),_c('ul',[_vm._v(_vm._s(_vm.content.description))])]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","href":this.content.link,"target":"_blank"},slot:"activator"},[_c('img',{attrs:{"src":__webpack_require__(133),"width":"16px"}})]),_vm._v(" "),_c('span',[_vm._v("Related Link")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"row":""}},_vm._l((_vm.content.techUsed),function(item,index){return _c('v-chip',{key:item.title,attrs:{"slot":"activator","disabled":"","selected":item.show},nativeOn:{"click":function($event){_vm.show(item.content, index)}},slot:"activator"},[_vm._v(_vm._s(item.title))])})),_vm._v(" "),_c('v-flex',{attrs:{"pt-2":""}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showItem)?_c('ul',{staticClass:"italic"},[_vm._v(_vm._s(_vm.showItemContent))]):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return projects; });
var projects = [{
  title: 'devSeater',
  institution: 'Individual Project',
  link: 'https://devseater.com',
  description: 'A social networking platform for software developers. With this project, it is intended to bring people who have close vision and similar skill sets together. Python, Flask and JavaScript were used in this project. ',
  techUsed: [{
    title: 'Python',
    show: false
  }, {
    title: 'Flask',
    content: 'A minimal web framework',
    show: false
  }, {
    title: 'JavaScript',
    show: false
  }, {
    title: 'Bootstrap',
    show: false
  }, {
    title: 'MariaDB',
    show: false
  }]
}, {
  title: 'Passaparola - Zor Oyun',
  institution: 'Individual Project',
  link: 'https://play.google.com/store/apps/details?id=com.metinorak.passaparola',
  description: 'Android game version of the Passaparola word contest TV show. Questions were prepared using\n    TDK data. And the local database synchronized with the parse server. In this project, Android SDK,\n    Java and Parse SDK were used.',
  techUsed: [{
    title: 'Java',
    show: false
  }, {
    title: 'Android SDK',
    content: 'A minimal web framework',
    show: false
  }, {
    title: 'Parse SDK',
    show: false
  }]
}, {
  title: 'Comment Repository (Yorum Deposu)',
  institution: 'Individual Project',
  link: 'http://yorumdeposu.com',
  description: 'Yorum Deposu (Comment repository) is a place where users can comment and give points about products, works, places etc. Also, it aims to users have an opinion about products, works, places etc.',
  techUsed: [{
    title: 'PHP',
    show: false
  }, {
    title: 'MySQL',
    show: false
  }]
}, {
  title: 'Çukurova Electromobile Team Website',
  institution: 'Çukurova Electromobile Student Club',
  link: 'http://cukurovaelektromobil.com',
  description: ' \xC7ukurova Electromobile is a student team that produces design and hardware for electromobile cars. And it is founded in 2013 by department of Mechanical Engineering in \xC7ukurova University.',
  techUsed: [{
    title: 'PHP',
    show: false
  }, {
    title: 'MySQL',
    show: false
  }]
}];

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return experiences; });
var experiences = [{
  title: 'Assistant Software Engineer',
  company: 'Huawei',
  date: 'July 2020 - Present'
}, {
  title: 'Software Development Intern',
  company: 'T-Soft E-Commerce Solutions',
  date: 'July 2018 - August 2018',
  description: 'Creating aws s3 analyzer using PHP and mongodb.',
  techUsed: [{
    title: 'PHP'
  }, {
    title: 'MongoDB',
    content: 'NoSQL Database System'
  }]
}, {
  title: 'Software Development Intern',
  company: 'F-Tech Labs',
  date: 'July 2017 - August 2017',
  description: 'Software development using C++ and Qt Framework and socket programming with QTcpSocket and QWebSocket ',
  techUsed: [{
    title: 'C++'
  }, {
    title: 'QT Framework',
    content: 'Cross-Platform application development framework'
  }]
}];

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"experience-page width-limit-800",attrs:{"flat":"","text-xs-left":""}},[_c('h3',{staticClass:"head"},[_vm._v("Work Experience")]),_vm._v(" "),_vm._l((_vm.experiences),function(item){return _c('experience-text',{key:item.company,attrs:{"content":item}})}),_vm._v(" "),_c('v-container',{staticClass:"divider-container",attrs:{"pa-0":"","pt-3":"","pb-3":""}},[_c('v-divider')],1),_vm._v(" "),_c('h3',{staticClass:"head"},[_vm._v("Projects")]),_vm._v(" "),_vm._l((_vm.projects),function(item){return _c('project-text',{key:item.company,attrs:{"content":item}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"page",attrs:{"flat":"","grid":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.pressed==='about')?_c('about-page'):_vm._e(),_vm._v(" "),(_vm.pressed==='education')?_c('education-page'):_vm._e(),_vm._v(" "),(_vm.pressed==='skills')?_c('skills-page'):_vm._e(),_vm._v(" "),(_vm.pressed==='experience')?_c('experience-page'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{ref:"app"},[(!_vm.enter)?_c('v-container',{staticClass:"title-container",attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"column":""}},[_c('name-bar',{key:"name-center"}),_vm._v(" "),_c('enter-bar',{on:{"enter":_vm.enterCV}})],1)],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.enter)?_c('v-container',{attrs:{"pl-0":"","pr-0":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-toolbar',{attrs:{"flat":"","fixed":"","text-xs-center":"","app":"","height":"160px"}},[_c('v-toolbar-items',[_c('v-layout',{attrs:{"column":""}},[(_vm.enter)?_c('name-bar'):_vm._e(),_vm._v(" "),_c('title-bar',{key:"title",on:{"changePage":_vm.change}})],1)],1)],1),_vm._v(" "),_c('v-content',[_c('page-view',{attrs:{"pressed":_vm.pageButton}})],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[51]);


// WEBPACK FOOTER //
// static/js/app.641db079c8e8e2abef20.js